/**
 * English: Chat Test "Talk to" targets — manager, master, or a station device agent id.
 * Thai: เป้าหมายแชทบนหน้า Chat Test — manager, master หรือ agent id ของอุปกรณ์
 *
 * Device keys from /api/agents are normally `device_{station}_{device_id}` but scope / filters
 * must not assume `device_` only (defensive; also avoids shared Redis conv when keys differ).
 */

export function isChatTestManagerTarget(chatTarget: string): boolean {
  return chatTarget === 'manager';
}

export function isChatTestMasterTarget(chatTarget: string): boolean {
  return chatTarget === 'master';
}

/** Any sidebar target other than manager or master — treated as direct device / employee chat. */
export function isChatTestDeviceTarget(chatTarget: string): boolean {
  return !isChatTestManagerTarget(chatTarget) && !isChatTestMasterTarget(chatTarget);
}
